import RidersPreventiveCheckupStep from "components/steps/RidersPreventiveCheckupStep";

export default RidersPreventiveCheckupStep;
